/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Newsletter_Science_FromInputs */

const en_why_listening_newsletter_science_from = /** @type {(inputs: Why_Listening_Newsletter_Science_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Science digest`)
};

const es_why_listening_newsletter_science_from = /** @type {(inputs: Why_Listening_Newsletter_Science_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen científico`)
};

/**
* | output |
* | --- |
* | "Science digest" |
*
* @param {Why_Listening_Newsletter_Science_FromInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_newsletter_science_from = /** @type {((inputs?: Why_Listening_Newsletter_Science_FromInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Newsletter_Science_FromInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_newsletter_science_from(inputs)
	return en_why_listening_newsletter_science_from(inputs)
});